import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IUser } from "../../model/types";
import { ILoginDTO } from "../model/types";
import { loginApi } from "./client";

export const useCheckUser = (
  options?: UseMutationOptions<unknown, AxiosError, ILoginDTO>
) => {
  return useMutation<unknown, AxiosError, ILoginDTO>({
    mutationFn: async (payload) => {
      const res = await loginApi.loginUser(payload);
      return res.data;
    },
    ...options,
  });
};

export const useLoginWithoutOTP = (
  options?: UseMutationOptions<IUser, AxiosError, ILoginDTO>
) => {
  return useMutation<IUser, AxiosError, ILoginDTO>({
    mutationFn: async (payload) => {
      const res = await loginApi.loginWithoutOTP(payload);
      return res.data;
    },
    ...options,
  });
};

export const useLoginUser = (
  options?: UseMutationOptions<IUser, AxiosError, ILoginDTO>
) => {
  return useMutation<IUser, AxiosError, ILoginDTO>({
    mutationFn: async (payload) => {
      const res = await loginApi.loginUser(payload);
      return res.data;
    },
    ...options,
  });
};
